import { useAntNotification } from 'components/ant/AntNotification';
import omsApi from 'utils/axios';

interface RedirectResponse {
  data: {
    payload: {
      redirect: string;
    };
  };
}

export default () => {
  const notification = useAntNotification();

  return (url: string) =>
    omsApi
      .get(url)
      .then((response: RedirectResponse) => {
        const redirectUrl = response.data.payload.redirect;

        if (redirectUrl) {
          window.open(redirectUrl, '_blank');
        }
      })
      .catch(() => {
        notification.error({ message: 'Could not redirect' });
      });
};
